module.exports = __webpack_public_path__ + "8b5c0cdb8e54ebe41d46cb63e0470377.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/disease_large_yellow.png
 ** module id = 1056
 ** module chunks = 0
 **/